import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { PackagePriceModel } from 'src/models/price/packagePrice';
import { API_url } from 'src/services/api.setup';

const API_Controller = '/PackagePrice';

export const PackagePriceService = {
  getAllData: async () => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getallPackagePrice`
      );

      return response.data as PackagePriceModel[];
    } catch (error) {
      throw error;
    }
  },

  getPackagePriceByCityForCarCategory: async (cityId, packageId, carcategoryId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/GetPackagePrice?cityId=${cityId}&packageId=${packageId}&carcategoryId=${carcategoryId}`
      );

      return response.data as PackagePriceModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (dataToAdd: PackagePriceModel) => {
    const data = dataToAdd.startDate;
    const reModel = {
      cityId: dataToAdd.cityId,
      packageId: dataToAdd.itemId,
      startDate: dataToAdd.startDate,
      endDate: dataToAdd.endDate,
      isActive: dataToAdd.isActive,
      listOfPrices: dataToAdd.prices.map((price) => ({
        carCategoryId: price.carCategoryId,
        amount: price.amount
      }))
    };

    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/AddBulkPackagePricesForCityAndService`,
        reModel
      );
      enqueueSnackbar(`Package ${dataToAdd.itemName} Added Successfully`, {
        variant: 'success'
      });
      return response.data as PackagePriceModel[];
    } catch (error) {
      enqueueSnackbar(`Package add unsuccessfully`, {
        variant: 'error'
      });
      throw error;
    }
  },

  editData: async (dataToEdit) => {
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/update`,
        dataToEdit
      );
      enqueueSnackbar(`Package edited Successfully`, {
        variant: 'success'
      });
      return respons.data as PackagePriceModel[];
    } catch (error) {
      throw error;
    }
  },
  addSingleData: async (dataToEdit) => {
    const reModel = {};
    try {
      const respons = await axios.post(
        `${API_url}${API_Controller}/create`,
        dataToEdit
      );
      enqueueSnackbar(`Package updated Successfully`, {
        variant: 'success'
      });
      return respons.data as PackagePriceModel[];
    } catch (error) {
      throw error;
    }
  },

  deleteAllData: async (itemId, cityId, data) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/DeleteAllPricesForPackage?packageId=${itemId}&cityId=${cityId}`
      );
      enqueueSnackbar(`Package ${data.itemName} deleted Successfully`, {
        variant: 'success'
      });
      return response.data as PackagePriceModel[];
    } catch (error) {
      enqueueSnackbar(`Package delete unsuccessfull`, {
        variant: 'error'
      });
      throw error;
    }
  },
};
